import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
import "core-js/modules/es.typed-array.uint8-array";
import "core-js/modules/es.typed-array.copy-within";
import "core-js/modules/es.typed-array.every";
import "core-js/modules/es.typed-array.fill";
import "core-js/modules/es.typed-array.filter";
import "core-js/modules/es.typed-array.find";
import "core-js/modules/es.typed-array.find-index";
import "core-js/modules/es.typed-array.for-each";
import "core-js/modules/es.typed-array.includes";
import "core-js/modules/es.typed-array.index-of";
import "core-js/modules/es.typed-array.iterator";
import "core-js/modules/es.typed-array.join";
import "core-js/modules/es.typed-array.last-index-of";
import "core-js/modules/es.typed-array.map";
import "core-js/modules/es.typed-array.reduce";
import "core-js/modules/es.typed-array.reduce-right";
import "core-js/modules/es.typed-array.reverse";
import "core-js/modules/es.typed-array.set";
import "core-js/modules/es.typed-array.slice";
import "core-js/modules/es.typed-array.some";
import "core-js/modules/es.typed-array.sort";
import "core-js/modules/es.typed-array.subarray";
import "core-js/modules/es.typed-array.to-locale-string";
import "core-js/modules/es.typed-array.to-string";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export function img2base64(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      result = _ref.result,
      _ref$contentType = _ref.contentType,
      contentType = _ref$contentType === void 0 ? 'image/png' : _ref$contentType,
      _ref$quality = _ref.quality,
      quality = _ref$quality === void 0 ? 1 : _ref$quality;

  return new Promise(function (resolve, reject) {
    var img = new Image();

    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        var cxt = c.getContext('2d');
        cxt.drawImage(img, 0, 0); // 得到图片的base64编码数据
        // console.log(contentType, quality)

        if (result === 'blob') {
          // 当canvas对象的原型中没有toBlob方法的时候，手动添加该方法
          if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
              value: function () {
                var _value = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(callback, type, quality) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = callback;

                          if (!_context.t0) {
                            _context.next = 8;
                            break;
                          }

                          _context.t1 = callback;
                          _context.t2 = this;
                          _context.next = 6;
                          return base64ToBlob(this.toDataURL(type, quality));

                        case 6:
                          _context.t3 = _context.sent;

                          _context.t1.call.call(_context.t1, _context.t2, _context.t3);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                }));

                function value(_x, _x2, _x3) {
                  return _value.apply(this, arguments);
                }

                return value;
              }()
            });
          }

          c.toBlob(function (blob) {
            resolve(blob);
          }, contentType, quality);
        } else {
          resolve(c.toDataURL(contentType, quality));
        } // resolve(result === 'blob' ? c.toB : c.toDataURL(contentType, quality))

      } catch (e) {
        reject(e);
      }
    };

    img.onerror = function (e) {
      reject(e);
    };

    img.setAttribute('crossOrigin', 'Anonymous');
    img.src = url;
  });
}
export function blobToBase64(_x4) {
  return _blobToBase.apply(this, arguments);
}

function _blobToBase() {
  _blobToBase = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(blob) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              try {
                var reader = new FileReader();

                reader.onload = function (e) {
                  resolve(e.target.result);
                };

                reader.readAsDataURL(blob);
              } catch (e) {
                console.warn('blobToBase64 error:', e);
                resolve(null);
              }
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _blobToBase.apply(this, arguments);
}

export function blobToObjUrl(_x5) {
  return _blobToObjUrl.apply(this, arguments);
}

function _blobToObjUrl() {
  _blobToObjUrl = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(blob) {
    var res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            window.URL = window.URL || window.webkitURL;

            if (!(window.URL && URL.createObjectURL)) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", URL.createObjectURL(blob));

          case 4:
            _context4.next = 9;
            break;

          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);
            console.warn('blobToObjUrl error:', blob);

          case 9:
            _context4.next = 11;
            return blobToBase64(blob);

          case 11:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 6]]);
  }));
  return _blobToObjUrl.apply(this, arguments);
}

export function base64ToBlob(_x6) {
  return _base64ToBlob.apply(this, arguments);
}

function _base64ToBlob() {
  _base64ToBlob = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(base64) {
    var arr, mime, bstr, n, u8arr, response, blob;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (!(window.atob && window.Uint8Array)) {
              _context5.next = 9;
              break;
            }

            arr = base64.split(',');
            mime = arr[0].match(/:(.*?);/)[1];
            bstr = window.atob(arr[1]);
            n = bstr.length;
            u8arr = new Uint8Array(n);

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }

            return _context5.abrupt("return", new Blob([u8arr], {
              type: mime
            }));

          case 9:
            _context5.next = 23;
            break;

          case 11:
            _context5.prev = 11;
            _context5.t0 = _context5["catch"](0);

            if (!window.fetch) {
              _context5.next = 21;
              break;
            }

            _context5.next = 16;
            return fetch(base64);

          case 16:
            response = _context5.sent;
            _context5.next = 19;
            return response.blob();

          case 19:
            blob = _context5.sent;
            return _context5.abrupt("return", blob);

          case 21:
            console.warn('base64ToBlob error', _context5.t0);
            return _context5.abrupt("return", null);

          case 23:
            return _context5.abrupt("return", null);

          case 24:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 11]]);
  }));
  return _base64ToBlob.apply(this, arguments);
}

export var base642ObjectUrl = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(b64Data) {
    var blob;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return base64ToBlob(b64Data);

          case 2:
            blob = _context2.sent;

            if (!blob) {
              _context2.next = 9;
              break;
            }

            _context2.next = 6;
            return blobToObjUrl(blob);

          case 6:
            _context2.t1 = _context2.sent;
            _context2.next = 10;
            break;

          case 9:
            _context2.t1 = b64Data;

          case 10:
            _context2.t0 = _context2.t1;

            if (_context2.t0) {
              _context2.next = 13;
              break;
            }

            _context2.t0 = b64Data;

          case 13:
            return _context2.abrupt("return", _context2.t0);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function base642ObjectUrl(_x7) {
    return _ref2.apply(this, arguments);
  };
}();
export function getImgUrl(url) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  if (!url) return '';
  return url.indexOf('?') === -1 ? "".concat(url, "?_=").concat(val) : "".concat(url, "&_=").concat(val);
}
export function isInlineData(url) {
  return /^data:image\/.*/i.test(url);
} // 低版本的ios 有base64 最大字符限制，这里默认取1M

export var IOS_MAX_BASE64 = 1400 * 1024;
var isSupport = null; // 部分低版本ios 机器不支持base64 新增 crossOrigin 属性,html2canvas 源码里面会有这种用法

export function getSupportBase64CrossStatus() {
  if (isSupport) {
    return isSupport;
  }

  isSupport = new Promise(function (resolve, reject) {
    var img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = function () {
      resolve(true);
    };

    img.onerror = function () {
      resolve(false);
    };

    img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2N48+bNfwAJUAPE01IbLQAAAABJRU5ErkJggg==';
  });
  return isSupport;
}